export default __webpack_public_path__ + "static/media/Twitter.8927536c.PNG";